import "./ServicesHub.module.css";
import MainHeader from "@/reusable_sections/Header";
import PageHero from "@/components/PageHero";
import OurSignatureSolutions from "./sections/OurSignatureSolutions";
import CommonQuestions from "./sections/CommonQuestions";
import CtaBand from "@/components/CtaBand";
import Footer from "@/reusable_sections/Footer";
export default function ServicesHubPage() {
  return <div className="min-h-screen bg-background text-foreground flex flex-col">
      {/* Sticky solid header */}
      <MainHeader />

      {/* Page Hero */}
      <PageHero breadcrumbLabel="Services Hub" eyebrow="WHAT WE DO" title="Roofing Services in Southampton" intro="Professional roofing services across Southampton, Hampshire & surrounding areas, providing new roofs, flat roofs, fascias and soffits, guttering, lead work, chimneys, repointing and roof cleaning." imageSrc="https://qualityroofsandlandscapes.co.uk/wp-content/uploads/2026/05/new-roof.jpg?v=8qmpfco9j2v" imageAlt="Quality roofing work completed in Southampton by Firststop Roofing Ltd" />

      {/* Main Content Sections */}
      <main className="flex-grow">
        <OurSignatureSolutions />
        <CommonQuestions />
        <CtaBand />
      </main>

      {/* Shared Footer */}
      <Footer />
    </div>;
}